// extracted by mini-css-extract-plugin
export default {"stripedRow":"UsersTable_stripedRow__wPQTr","totalRow":"UsersTable_totalRow__ux1bh"};